module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort2-a5fc98bd74f835ec0a5725823cd13db6.svg";